module.exports = __webpack_public_path__ + "img/mycoupon_ico_received.a02e3bd2.png";